<template>
  <div class="card ondemand">
    <div class="card-content">
      <question-title :question="question" class="mb2"></question-title>
      <div class="ql-viewer" v-html="message"></div>
      <OnDemandButton
        :question="question"
        :buttonText="buttonText"
        :organizationLocationId="organizationLocationId"
      />
    </div>
  </div>
</template>

<script>
import baseQuestion from "./baseQuestion";
import OnDemandButton from "./OnDemandButton";
export default {
  name: "ondemand",
  mixins: [baseQuestion],

  components: {
    OnDemandButton
  },

  computed: {
    field() {
      return this.question.fields[0] || {};
    },
    message() {
      return this.field.ondemandMessage;
    },
    buttonText() {
      return this.field.ondemandButtonText;
    },
    organizationLocationId() {
      return this.field.organizationLocationId;
    }
  }
};
</script>

<style lang="scss" scoped>
.case-grid {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
  li {
    width: 29%;
    margin-right: 3%;
    height: 400px;
    margin-bottom: 15px;
    box-shadow: 0px 4px 20px rgba(23, 128, 186, 0.2);
    text-align: center;
    padding-bottom: 40px;
    position: relative;
    .image {
    }
    h4 {
      font-size: 32px;
      text-align: center;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .button {
      margin: 0 auto;
      width: 80%;
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      height: auto;
      white-space: initial;
      line-height: 32px;
      padding-top: 15px;
      padding-bottom: 15px;
    }
  }
}
</style>
